import { render, staticRenderFns } from "./ImprovementReportList.vue?vue&type=template&id=dfb4ca60"
import script from "./ImprovementReportList.vue?vue&type=script&lang=js"
export * from "./ImprovementReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports